import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

function SubscriptionMemberships() {
  function toggleCompedSubscription(params) {
    return AuthAxios.post(`${DataApiUrl}/admin/subscription-memberships/toggleCompedSubscription`, params)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });
  }

  return { toggleCompedSubscription };
}

export default SubscriptionMemberships;
